import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: "It's not that it doesn't get done. It just takes longer to answer those questions three weeks down the line than if they're answered three days into it.", a: '' },
    { q: "I think it's a really good service to be able to offer — especially with rejections and with those that we want to keep an eye on for the next three to six months.", a: '' },
    { q: 'The pitch gets the meeting. The Diligence Pack gets the money.', a: '' },
    { q: "There's quite a few companies that we don't even accept on our platform because they're below being ready — a lot of founders think in terms of product, not in terms of the investment thesis.", a: '' },
    { q: "I'd love to be able to look at business plans and know that there are questions they'll have to field that they're just not prepared for — which is why some of this would be quite good.", a: '' },
    { q: 'If you can demonstrate that a company is really well organised and clearly very well run, would I pay a 10% premium? Of course I would.', a: '' },
    { q: 'Better organised businesses do better. Better organised businesses grow faster.', a: '' },
];

const GLOWS = [
    { top: -110, left: -90, size: 480, c: 'rgba(252,119,133,0.42)' },
    { top: 20, right: -120, size: 540, c: 'rgba(74,103,255,0.40)' },
    { bottom: -150, left: '12%', size: 520, c: 'rgba(74,103,255,0.34)' },
    { bottom: -110, right: '6%', size: 420, c: 'rgba(252,119,133,0.32)' },
];

const pos = (v) => (v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v);

const AngelQuotesSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: pos(g.top), bottom: pos(g.bottom), left: pos(g.left), right: pos(g.right), width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(78px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <h2 className="lp-h2" data-lp-reveal>What people in the room are saying.</h2>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>{item.q}</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-foot">
                <p data-lp-reveal>Diligentsia is free to angel networks. No platform fees, no per-application charges, no commitment required.</p>
                <div className="lp-dots" style={{ margin: 0, padding: 0 }}>
                    {Array.from({ length: pages }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AngelQuotesSection;
